import { Facebook, Instagram, MessageCircle, Send } from "lucide-react";

export const LOGO = "/logo.webp";

export const CONTACT_EMAIL = "info@arijitcapital.com";

export const publicSocials = {
  instagram: "https://www.instagram.com/arijitcapital?stkn=NngyMjhiZXZ4cTJk&utm_source=qr",
  facebook: "https://www.facebook.com/share/1CnYaeb6dE/?mibextid=wwXIfr",
};

export const communities = [
  { key: "whatsapp", icon: MessageCircle, label: "WhatsApp", detail: "Daily community access", color: "green", gated: true },
  { key: "telegram", icon: Send, label: "Telegram", detail: "Join Arijit Capital", color: "blue", gated: true },
  { key: "instagram", icon: Instagram, label: "Instagram", detail: "Reels, charts & notes", color: "pink", href: publicSocials.instagram },
  { key: "facebook", icon: Facebook, label: "Facebook", detail: "Long-form learning", color: "indigo", href: publicSocials.facebook },
];

export const topics = [
  ["01", "Price Action", "Read the story behind every candle, level, and move."],
  ["02", "Risk Management", "Protect your capital before chasing your next setup."],
  ["03", "Trader Psychology", "Build the clarity and discipline to follow your plan."],
  ["04", "Options Setups", "Understand the framework, not just the entry call."],
];

export const faqs = [
  ["Is this financial advice?", "No. Arijit Capital is a personal learning community. Everything shared is for education and awareness only."],
  ["Who is this community for?", "Anyone who wants to understand markets with more clarity, patience, and a process-first mindset."],
  ["Why do I need to sign in to join?", "Signing in with Google keeps the WhatsApp and Telegram groups for genuine learners only. It takes five seconds and we never post on your behalf."],
  ["Is Arijit Capital SEBI registered?", "No. Arijit Capital is not SEBI registered. Please read the full disclaimer below before joining."],
];
